const fmtNumber = (n) => (n || 0).toLocaleString();

/**
 * Ranked bar-list of AR filters by number of times each was selected (fancam.arFilter.apply),
 * same visual language as ModuleBreakdownTable. Selections fire before a post exists, so they
 * carry no fancamId and can't join into the per-item drill-down list/drawer.
 */
const EffectUsageSummary = ({ effects, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-[#E2E8F0] p-5 space-y-3 animate-pulse">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-6 w-full bg-[#F1F5F9] rounded" />
        ))}
      </div>
    );
  }

  if (!effects?.length) {
    return null;
  }

  const maxCount = Math.max(1, ...effects.map((e) => e.count || 0));

  return (
    <div className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden">
      <div className="px-5 py-3.5 border-b border-[#E2E8F0] bg-[#F8FAFC]">
        <p className="text-[13px] font-semibold text-[#0F172A]">AR filters selected</p>
        <p className="text-[11px] text-[#94A3B8]">Number of times each filter was selected</p>
      </div>

      <div className="py-2">
        {effects.map((effect) => {
          const barWidth = `${Math.max(4, (effect.count / maxCount) * 100)}%`;
          return (
            <div
              key={effect.effectId || effect.effectName}
              className="flex items-center gap-3 px-5 py-2.5"
            >
              <span
                className="shrink-0 rounded-full bg-[#F59E0B]"
                style={{ width: 6, height: 6 }}
              />
              <span className="shrink-0 text-[13px] font-medium text-[#334155] w-[130px] truncate">
                {effect.effectName}
              </span>
              <span className="flex-1 h-1.5 rounded-full bg-[#F1F5F9] overflow-hidden">
                <span
                  className="block h-full rounded-full bg-[#F59E0B]"
                  style={{ width: barWidth }}
                />
              </span>
              <span className="shrink-0 text-[13px] font-semibold text-[#0F172A] tabular-nums w-12 text-right">
                {fmtNumber(effect.count)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EffectUsageSummary;
